import { ModelOrdenServicio, ModelOrdenServicioListar } from 'api/types';
import { get_month_shortcut } from './date';

export function get_order_id(
  order: ModelOrdenServicio | ModelOrdenServicioListar,
): string {
  return `${get_month_shortcut(order.fecha_recibido)}-${order.id}`;
}
